import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createDispute } from "@/services/disputes.service";

export const useCreateDispute = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createDispute,
    onSuccess: () => {
      // Both the paginated list and the stats card need to reflect the new
      // record — invalidate every "chargebacks" query (all page/size/status/
      // search variants share that key prefix) plus the stats query.
      queryClient.invalidateQueries({ queryKey: ["chargebacks"] });
      queryClient.invalidateQueries({ queryKey: ["chargebackStats"] });
    },
  });
};